import * as actions from './actions'

export const executeInitEvents = async () => {
  const initEvents = Array.from(document.querySelectorAll('[data-axe-on]')).filter((elm) =>
    (elm as HTMLElement).dataset.axeOn.startsWith('init:')
  )
  const initActions = initEvents.map((elm) => {
    const [event, actionName, ...params] = (elm as HTMLElement).dataset.axeOn.split(':')
    const action = actions[actionName]
    if (action) {
      return actions[actionName](event, elm, ...params)
    }
    return Promise.resolve()
  })
  return Promise.all(initActions)
}

export const executeLoadEvents = async () => {
  const loadEvents = Array.from(document.querySelectorAll('[data-axe-on]')).filter((elm) =>
    (elm as HTMLElement).dataset.axeOn.startsWith('load:')
  )
  const loadActions = loadEvents.map((elm) => {
    const [event, actionName, ...params] = (elm as HTMLElement).dataset.axeOn.split(':')
    const action = actions[actionName]
    if (action) {
      return actions[actionName](event, elm, ...params)
    }
    return Promise.resolve()
  })
  return Promise.all(loadActions)
}
